import { TableCell, TableRow, Stack } from "@mui/material";

import { useState } from "react";
import DeleteElComponent from "../../_components/DeleteElComponent";
import { TraineeProps } from "@/types/admin_types";
import DialogComponent from "../../_components/DialogComponent";
import { Edit, Eye, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import CustomTableCell from "@/components/tables/CustomTableCell";
import UpdateTraineeForm from "./UpdateTraineeForm";
import TraineeCard from "./TraineeCard";

type Props = {
  el: TraineeProps;
  index: number;
};
export default function TraineeRow({ el, index }: Props) {
  const [openDelete, setOpenDelete] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [openDetails, setOpenDetails] = useState(false);

  return (
    <>
      <TableRow hover key={el?.id}>
       
        <CustomTableCell text={index + 1}/>
        <CustomTableCell text={el?.name}/>
        <CustomTableCell text={el?.email}/>
        <CustomTableCell text={el?.institution}/>

        <TableCell>
          <Stack display="flex" gap={1} direction="row">
            <DialogComponent
              open={openDetails}
              setOpen={setOpenDetails}
              title={"Trainee Card"}
              subtitle={"All information you need to know about a trainee"}
              closeBtn={false}
              trigger={
                <Button variant="ghost" className="p-2 border">
                  <Eye
                    strokeWidth={2.2}
                    size={18}
                    className=" text-sky-500"
                  />
                </Button>
              }
              components={<TraineeCard el={el} />}
            />

            <DialogComponent
              open={openUpdate}
              setOpen={setOpenUpdate}
              title={"title"}
              subtitle={"subtitle"}
              trigger={
                <Button variant="ghost" className="p-2 border">
                  <Edit
                    strokeWidth={2.2}
                    size={18}
                    className=" text-green-600"
                  />
                </Button>
              }
              components={<UpdateTraineeForm el={el} setOpen={setOpenUpdate} />}
            />

            <DialogComponent
              open={openDelete}
              setOpen={setOpenDelete}
              title="Delete File"
              subtitle="Are you sure you want to delete this file?"
              trigger={
                <Button variant="ghost" className="p-2 border">
                  <Trash2
                    strokeWidth={2.2}
                    size={18}
                    className=" text-rose-700"
                  />
                </Button>
              }
              components={
                <DeleteElComponent
                  preview={el?.name}
                  setOpen={setOpenDelete}
                  url={`/api/v1/admin/users/${el?.id}`}
                  invalidate="admin-users"
                  disabled
                />
              }
            />
          </Stack>
        </TableCell>
      </TableRow>
    </>
  );
}